import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import { UserService } from '../services';

@Injectable()
export class ITGroupGuard implements CanActivate, OnDestroy {

  private _userSubscription: Subscription;
  private _user: any;

  constructor(
    private _router: Router,
    private _userService: UserService
  ) {
    this._userSubscription = this._userService.getUser()
      .subscribe(user => this._user = user);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
  {
    if(this._user && this._user.group === 'IT') return true;
    this._router.navigate(['account']);
    return false;
  }

  ngOnDestroy() {
    if(this._userSubscription) this._userSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/core/guards/it-group.guard.ts